import type { FC } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import type { IModal } from "@Components/Modal";
import { Modal } from "@Components/Modal";

import type { IInformationContent } from "../common/InformationContent";
import { InformationContent } from "../common/InformationContent";

import * as css from "./AdBlockModal.module.css";

export interface IAdBlockModal extends IModal {
    informationContent: IInformationContent;
}

const AdBlockModal: FC<IAdBlockModal> = (props) => {
    const onButtonClick = () => {
        sendTelemetryEvent({
            eventName: "cshbck-adBlockOnBtn",
            actionType: "Click",
        });

        window.location.reload();
    };

    return (
        <Modal {...props} className={css.adBlockModalComponent} isOpen hideCloseButton closeOnBlur={false}>
            <InformationContent {...props.informationContent} onClickButton={onButtonClick} />
        </Modal>
    );
};

export default AdBlockModal;
